import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { AttributeTemplateResponse } from "@/models/api/administration/servicesAndAttributes/AttributeTemplate";
import { AttributeTemplateAddEdit } from "@/models/api/administration/servicesAndAttributes/AttributeTemplateAddEdit";

//#region Routes
export const URL_GET_ATTRIBUTE_TEMPLATE_PAGED = "/Attribute/Template/Paged";
export const URL_POST_REMOVE_ATTRIBUTE_TEMPLATE = "/Attribute/Template/${AttributeTemplateId}/Remove";
export const URL_POST_ADD_ATTRIBUTE_TEMPLATE = "/Attribute/Template/Add";
export const URL_POST_EDIT_ATTRIBUTE_TEMPLATE = "/Attribute/Template/${AttributeTemplateId}/Edit";

//#endregion

const _getAttributeTemplates = new CancellableHelper<AttributeTemplateResponse>(
  URL_GET_ATTRIBUTE_TEMPLATE_PAGED,
  AttributeTemplateResponse
);
_getAttributeTemplates.jsonSerializer = true;
export const getAttributeTemplates = async (
  genericTableRequest: GenericTableRequest
): Promise<AttributeTemplateResponse> => {
  return await _getAttributeTemplates.get(genericTableRequest);
};

const _removeAttributeTemplate = new CancellableHelper<null>(URL_POST_REMOVE_ATTRIBUTE_TEMPLATE, null, true);
export const removeAttributeTemplate = async (attributeTemplateId: number): Promise<null> => {
  return await _removeAttributeTemplate.post({ AttributeTemplateId: attributeTemplateId }, null);
};

const _addAttributeTemplate = new CancellableHelper<null>(URL_POST_ADD_ATTRIBUTE_TEMPLATE, null, true);
export const addAttributeTemplate = async (attributeTemplateAddEdit: AttributeTemplateAddEdit): Promise<null> => {
  return await _addAttributeTemplate.post({}, attributeTemplateAddEdit);
};

const _editAttributeTemplate = new CancellableHelper<null>(URL_POST_EDIT_ATTRIBUTE_TEMPLATE, null, true);
export const editAttributeTemplate = async (
  attributeTemplateAddEdit: AttributeTemplateAddEdit,
  attributeTemplateId: number
): Promise<null> => {
  return await _editAttributeTemplate.post({ AttributeTemplateId: attributeTemplateId }, attributeTemplateAddEdit);
};
